module.exports = __webpack_public_path__ + "static/media/serve.599f3dc7.jpg";